module.exports = __webpack_public_path__ + "static/media/close.51b6f612.svg";